import { Box, Typography } from "@material-ui/core";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { IApplicationState } from "redux/root-reducer";
import { isLandlordTypeGuard } from "common/models/userInfo";
import { EmailVerificationStepper } from "./EmailVerificationStepper";

export const EmailAddress: React.FC = () => {
  const { t } = useTranslation();
  const [stepperOpen, setStepperOpen] = useState(false);

  const currentEmail = useSelector((state: IApplicationState) => {
    const userInfo = state.common.currentUserInfo;
    if (isLandlordTypeGuard(userInfo)) return null;
    return userInfo.Email;
  });

  return (
    <>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        onClick={() => setStepperOpen(true)}
        style={{ cursor: "pointer" }}
      >
        <Box>
          <Typography variant="h4">{t("Email address")}</Typography>
          {currentEmail && (
            <Typography variant="body2" color="textSecondary">
              {currentEmail}
            </Typography>
          )}
        </Box>
        <Typography variant="body2" color="primary">
          {currentEmail ? t("Change") : t("Add")}
        </Typography>
      </Box>

      <EmailVerificationStepper
        open={stepperOpen}
        onClose={() => setStepperOpen(false)}
        currentEmail={currentEmail}
      />
    </>
  );
};
